export default __webpack_public_path__ + "static/media/MainHero.f0a10b7c.png";